import commonHelper from '@/app/utility/common.helper.utility';
import advanceSearchModal from './advanceSearch';
import tenantInvoiceDetailsModal from './tenantInvoiceDetails';
import masterleaseAgreement from '../../leases/masterAgreement';
import tenantLease from '../../leases/tenantLease';
import { required } from 'vuelidate/lib/validators';
import appStrings from '@/app/utility/string.utility';
import URL_UTILITY from '../../../../../utility/url.utility';
export default {
  name: 'tenantInvoices',
  watch: {
    currentPage: function() {
      this.getTenantInvoicesList();
    },
    perPage: function() {
      this.currentPage = 1;
      this.getTenantInvoicesList();
    },
    selectAllCheckBox: function() {
      this.checkUncheckAll();
    }
  },
  components: {
    commonHelper,
    advanceSearchModal,
    tenantInvoiceDetailsModal,
    masterleaseAgreement,
    tenantLease
  },
  data() {
    return {
      payload: null,
      showAdvanceSearchModal: false,
      showTenantInvoiceDetails: false,
      legalEntity: {
        value: null,
        text: null
      },
      operatingUnit: {
        value: null,
        text: null
      },
      selectedMasterleaseAgreement: {
        value: null,
        text: null
      },
      selectedTenantLease: {
        value: null,
        text: null
      },
      status: {
        value: null,
        text: null
      },
      unsubscribe: null,
      showDetails: false,
      showValueSetModal: false,
      parent_value_set_id: null,
      unitName: null,
      loader: false,
      unitDisplay: null,
      perPage: commonHelper.perPageRecord,
      pageOptions: commonHelper.getPageOption(),
      totalRows: null,
      currentPage: 1,
      searchParams: null,
      leaseUnitRowDetails: null,
      gridData: [],
      gridFields: [
        {
          key: 'selectBox',
          label: 'Select',
          stickyColumn: true,
          variant: 'primary'
        },
        {
          key: 'source_name'
        },
        {
          key: 'bill_status_vset_meaning',
          label: 'Bill Status'
        },
        {
          key: 'bill_no'
        },
        {
          key: 'trx_type',
          label: 'Transaction Type'
        },
        {
          key: 'lease_agreement_no',
          label: 'MLA No.'
        },
        {
          key: 'lease_tenant_agreement_no',
          label: 'Tenant Lease No.'
        },
        {
          key: 'lease_schedule_type_vset_meaning',
          label: 'Schedule Type'
        },
        {
          key: 'bill_uom_meaning',
          label: 'Bill UOM'
        },
        {
          key: 'third_party_gstn',
          label: 'Third Party GSTN'
        },
        {
          key: 'first_party_gstn',
          label: 'First Party GSTN'
        },
        {
          key: 'due_date'
        },
        {
          key: 'gl_date',
          label: 'GL Date'
        },
        {
          key: 'billing_period_start_date',
          label: 'Billing From Date'
        },
        {
          key: 'billing_period_end_date',
          label: 'Billing End Date'
        },
        {
          key: 'currency'
        },
        {
          key: 'exchange_rate'
        },
        {
          key: 'total_amount'
        },
        {
          key: 'customer_id'
        },
        {
          key: 'customer_name'
        },
        {
          key: 'customer_site_id'
        },
        {
          key: 'customer_site'
        },
        {
          key: 'customer_site_address'
        },
        {
          key: 'lease_prj_name',
          label: 'Project'
        },
        {
          key: 'lease_tower_name',
          label: 'Tower'
        },
        {
          key: 'lease_floor_name',
          label: 'Floor'
        },
        {
          key: 'lease_prj_unit_name',
          label: 'Unit Name'
        },
        {
          key: 'recovery_type_vset_meaning',
          label: 'Recovery Type'
        },
        {
          key: 'request_id',
          label: 'Request Num'
        },
        {
          key: 'error_msg'
        }
      ],
      billHdrId: null,
      tenantInvoiceDetails: null,
      modalName: null,
      selectAllCheckBox: false,
      showAlert: false,
      isSuccess: false,
      responseMsg: null,
      downloadLog: URL_UTILITY.getDownloadLOGUrl,
      defaultValue: {
        text: null,
        value: null
      },
      calculateAmt: 0
    };
  },
  validations: {
    operatingUnit: {
      text: {
        required
      }
    },
    legalEntity: {
      text: {
        required
      }
    }
  },
  mounted() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'shared/setActionName') {
        const actionName = state.shared.actionName;
        if (actionName === 'save') {
          this.processInvoice();
        }
        if (
          actionName === 'download' &&
          !this.showTenantInvoiceDetails &&
          !this.showDetails
        ) {
          this.loader = true;
          /**
           * @param(payload, 'action name', 'file name')
           */
          const downloadpayload = { ...this.payload };
          downloadpayload.pagination._limit = this.totalRows;
          this.downloadExcel.downloadData(
            downloadpayload,
            'leaseInvoice/getTenatnInvoiceList',
            'tenant-invoices',
            () => (this.loader = false)
          );
        }
      }
    });
  },
  methods: {
    getTenantInvoicesList() {
      // to get invoices list
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.loader = true;
        this.payload = {
          pagination: {
            _page: this.currentPage - 1,
            _limit: this.perPage
          }
        };
        if (!this.searchParams) {
          this.payload.searchParams = {
            le_id: this.legalEntity.value,
            ou_id: this.operatingUnit.value,
            lease_master_agreement_hdr_id: this.selectedMasterleaseAgreement
              .value,
            lease_tenant_agreement_hdr_id: this.selectedTenantLease.value,
            bill_status_vset: this.status.value
          };
        } else {
          this.payload.searchParams = this.searchParams;
        }
        this.$store
          .dispatch('leaseInvoice/getTenatnInvoiceList', this.payload)
          .then(resp => {
            this.loader = false;
            if (resp.status === 200) {
              this.gridData = resp.data.data.page.map(data => {
                data.selectBox = false;
                return data;
              });
              this.totalRows = resp.data.data.total_elements;
            }
          })
          .catch(() => {
            this.loader = false;
          });
      }
    },
    processInvoice() {
      const selectedRows = this.gridData.filter(data => data.selectBox);
      if (selectedRows && selectedRows.length > 0) {
        const prepareData = selectedRows.map(data => {
          return {
            id: data.bill_hdr_id
          };
        });
        const payload = {
          bill_hdr_id: { bill_id: prepareData },
          ou_id: this.operatingUnit.value
        };
        this.loader = true;
        this.$store
          .dispatch('leaseInvoice/processInvoice', payload)
          .then(response => {
            this.loader = false;
            this.showAlert = true;
            if (response.status === 201) {
              this.isSuccess = true;
              this.responseMsg = response.data.message;
            } else {
              this.isSuccess = false;
              this.responseMsg = response.response.data.message;
            }
          })
          .catch(() => {
            this.loader = false;
          });
      }
    },
    clearSearchFilters() {
      this.legalEntity = {
        value: null,
        text: null
      };
      this.operatingUnit = {
        value: null,
        text: null
      };
      this.selectedMasterleaseAgreement = {
        value: null,
        text: null
      };
      this.selectedTenantLease = {
        value: null,
        text: null
      };
      this.status = {
        value: null,
        text: null
      };
      this.gridData = [];
      this.totalRows = null;
      this.currentPage = 1;
    },
    hideAddLeaseModal() {
      this.showAddLeaseUnitModal = false;
    },
    selectedvalueSet(item) {
      if (this.vsetCode === appStrings.VALUESETTYPE.LEASE_PROJECT_LIST) {
        this.leasePrj = {
          value: item.value_set_dtl_id,
          text: item.lease_prj_name
        };
      } else if (this.vsetCode === appStrings.VALUESETTYPE.LEASE_TOWER_LIST) {
        this.leaseTwr = {
          value: item.value_set_dtl_id,
          text: item.value_code
        };
        this.parent_value_set_id = this.leaseTwr.value;
      } else if (this.vsetCode === appStrings.VALUESETTYPE.LEASE_FLOOR_LIST) {
        this.leaseFloor = {
          value: item.value_set_dtl_id,
          text: item.value_code
        };
      } else if (this.vsetCode === appStrings.VALUESETTYPE.LEGAL_ENTITY_LIST) {
        this.legalEntity = {
          value: item.value_set_dtl_id,
          text: item.value_code
        };
        this.operatingUnit = {
          value: null,
          text: null
        };
      } else if (this.vsetCode === appStrings.VALUESETTYPE.OU_LIST) {
        this.operatingUnit = {
          value: item.value_set_dtl_id,
          text: item.value_code
        };
      } else if (this.vsetCode === 'SCHEDULE_STATUS_VSET') {
        this.status.text = item.value_meaning;
        this.status.value = item.value_code;
      }
    },
    openValueSetModal(vsetCode) {
      if (vsetCode === appStrings.VALUESETTYPE.LEASE_TOWER_LIST) {
        this.parent_value_set_id = this.leasePrj.value;
      } else if (vsetCode === appStrings.VALUESETTYPE.LEASE_TOWER_LIST) {
        this.parent_value_set_id = this.leasePrj.value;
      } else if (vsetCode === appStrings.VALUESETTYPE.OU_LIST) {
        this.parent_value_set_id = this.legalEntity.value;
      } else if (vsetCode === 'SCHEDULE_STATUS_VSET') {
        this.parent_value_set_id = null;
      }

      this.vsetCode = vsetCode;
      this.showValueSetModal = true;
      this.setTimeVsetCode = setTimeout(() => {
        const vSetData = {
          valueSetName: vsetCode,
          multiFlag: null
        };
        this.eventBus.$emit('valueSetCode', vSetData);
      }, 0);
    },
    closeValueSetModal() {
      this.showValueSetModal = false;
    },
    rowSelected(item) {
      this.billHdrId = item.bill_hdr_id;
      this.tenantInvoiceDetails = item;
      this.showTenantInvoiceDetails = true;
    },
    closeLeaseUnitDetail() {
      this.showDetails = false;
    },
    updateLeaseUnitList() {
      this.leaseUnitData = [];
    },
    showHideAdvSearchModal(flag) {
      this.showAdvanceSearchModal = flag;
    },
    advanceSearch(params) {
      this.legalEntity.text = params.le_name;
      this.legalEntity.value = params.searchParams.le_id;
      this.operatingUnit.text = params.ou_name;
      this.operatingUnit.value = params.searchParams.ou_id;
      this.searchParams = params.searchParams;
      this.getTenantInvoicesList();
      this.showAdvanceSearchModal = false;
    },
    openTenantInvoiceModal(flag, modalName) {
      this.showTenantInvoiceDetails = flag;
      this.modalName = modalName;
    },
    selectedLeaseMaster(masterLease) {
      this.selectedMasterleaseAgreement.value =
        masterLease.lease_master_agreement_hdr_id;
      this.selectedMasterleaseAgreement.text = masterLease.lease_agreement_no;
      this.openTenantInvoiceModal(false, null);
    },
    selectedLeaseTenant(tenantLease) {
      this.selectedTenantLease.value =
        tenantLease.lease_tenant_agreement_hdr_id;
      this.selectedTenantLease.text = tenantLease.lease_tenant_agreement_no;
      this.openTenantInvoiceModal(false, null);
    },
    calculateAmount() {
      let sum = 0;
      this.gridData.forEach(element => {
        if (element.selectBox) {
          sum += parseFloat(element.total_amount.replaceAll(',', ''));
        }
        this.calculateAmt = parseFloat(sum).toFixed(2);
      });
    },
    selectBoxChecked(flag, index) {
      this.gridData[index].selectBox = flag;
      this.calculateAmount();
    },
    checkUncheckAll() {
      this.gridData = this.gridData.map(data => {
        if (data.request_id) {
          if (!/e/i.test(data.bill_status_vset)) {
            data.selectBox = false;
          } else {
            data.selectBox = this.selectAllCheckBox;
          }
        } else {
          data.selectBox = this.selectAllCheckBox;
        }
        return data;
      });
      this.calculateAmount();
    },
    validateCheckBox(row) {
      if (row.request_id) {
        if (!/e/i.test(row.bill_status_vset)) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    mainSearch() {
      this.searchParams = null;
      this.getTenantInvoicesList();
    },
    onDeletion() {
      setTimeout(() => {
        this.showTenantInvoiceDetails = false;
        this.getTenantInvoicesList();
      }, 1000);
    },
    clearVsetValues(vsetCode) {
      if (vsetCode === this.legalEntity.value) {
        this.legalEntity = this.defaultValue;
      } else if (vsetCode === this.operatingUnit.value) {
        this.operatingUnit = this.defaultValue;
      } else if (vsetCode === this.status.value) {
        this.status = this.defaultValue;
      }
    }
  },
  beforeDestroy() {
    this.unsubscribe();
    this.$store.dispatch('leaseInvoice/saveAdvSearchFilters', null);
  }
};
